import { type EVENT_PRODUCT_CATEGORY } from 'packages/core/src/features';

import {
	type CHIP_TYPE,
	type COUNTRY,
	type CURRENCY,
	type EVENT_CATEGORY,
	type LANGUAGE,
	type PAYMENT_METHOD,
	type REGION,
	type REQ_PROVIDER,
} from '../../constants';
import { type TypedEnumMap } from '../main';

export default {
	'close.label': 'Zavřít',
	'yes.label': 'Ano',
	'no.label': 'Ne',
	language: {
		label: 'Neznámo',
		label_1: 'Čeština',
		label_2: 'Slovenština',
		label_3: 'Angličtina',
		label_4: 'Němčina',
		label_5: 'Francouzština',
		label_6: 'Španělština',
		label_7: 'Ruština',
		label_8: 'Norština',
		label_9: 'Švédština',
	} satisfies TypedEnumMap<'label', LANGUAGE>,
	chipType: {
		label: 'Neznámo',
		label_1: 'Běžný čip',
		label_2: 'Čip dobitý online',
		label_3: 'VIP čip',
		label_4: 'Anonymní transakce',
		label_5: 'Zaměstnanecký čip',
		label_6: 'Čip pro hosty',
	} as const satisfies TypedEnumMap<'label', CHIP_TYPE>,
	country: {
		label: 'Neznámo',
		label_1: 'Česká republika',
		label_2: 'Slovensko',
		label_3: 'Rakousko',
		label_4: 'Spojené království Velké Británie a Severního Irska',
		label_5: 'Srbsko',
		label_6: 'Belgie',
		label_7: 'Bulharsko',
		label_8: 'Chorvatsko',
		label_9: 'Kypr',
		label_10: 'Dánsko',
		label_11: 'Estonsko',
		label_12: 'Finsko',
		label_13: 'Francie',
		label_14: 'Německo',
		label_15: 'Řecko',
		label_16: 'Maďarsko',
		label_17: 'Irsko',
		label_18: 'Itálie',
		label_19: 'Lotyšsko',
		label_20: 'Litva',
		label_21: 'Lucembursko',
		label_22: 'Malta',
		label_23: 'Polsko',
		label_24: 'Portugalsko',
		label_25: 'Rumunsko',
		label_26: 'Slovinsko',
		label_27: 'Španělsko',
		label_28: 'Švédsko',
		label_29: 'Nizozemsko',
		label_30: 'Island',
		label_31: 'Lichtenštánsko',
		label_32: 'Norsko',
		label_33: 'Švýcarsko',
	} as const satisfies TypedEnumMap<'label', COUNTRY>,
	currency: {
		label: 'Neznámo',
		label_1: 'Koruna',
		label_2: 'Euro',
		label_3: 'Srbský dinár',
		label_4: 'Britská libra',
		label_5: 'Polský zlotý',
	} as const satisfies TypedEnumMap<'label', CURRENCY>,
	reqProvider: {
		label: 'Neznámo',
		label_1: 'Email',
		label_2: 'Facebook',
		label_3: 'Google',
		label_4: 'Apple',
	} as const satisfies TypedEnumMap<'label', REQ_PROVIDER>,
	eventCategory: {
		label: 'Neznámo',
		label_1: 'Hudba',
		label_2: 'Gastro',
		label_3: 'Kultura',
		label_4: 'Víno',
		label_5: 'Sportovní',
		label_6: 'Sériová akce',
		label_7: 'Festival',
		label_8: 'Děti',
		label_9: 'Párty',
		label_10: 'Divadlo',
		label_11: 'Koncert',
		label_12: 'Pivo',
	} as const satisfies TypedEnumMap<'label', EVENT_CATEGORY>,
	eventKind: {
		label: 'Neznámo',
		label_1: 'Jednorázová akce',
		label_2: 'Dlouhodobý provoz',
		/** TODO: missing core enum EVENT_KIND */
	} as const satisfies TypedEnumMap<'label', 1 | 2>,
	eventSize: {
		label: 'Neznámo',
		label_1: 'Malá',
		label_2: 'Střední',
		label_3: 'Velká',
		/** TODO: missing core enum EVENT_SIZE */
	} as const satisfies TypedEnumMap<'label', 1 | 2 | 3>,
	eventType: {
		label: 'Neznámo',
		label_1: 'Vstupenky',
		label_2: 'Balíčky',
		label_3: 'Dobití kreditu',
		/** TODO: missing core enum EVENT_TYPE */
	} as const satisfies TypedEnumMap<'label', 1 | 2 | 3>,
	itemType: {
		label: 'Neznámo',
		label_1: 'Vstup na akci',
		label_2: 'Parkování',
		label_3: 'NFC čip',
		label_4: 'Vstup na atrakci',
		label_5: 'Workshop',
		label_6: 'Produkt',
		label_7: 'Opakovaný vstup na akci',
		label_8: 'NFC čip VIP',
		label_9: 'Zóna',
		/** TODO: missing core enum ITEM_TYPE */
	} as const satisfies TypedEnumMap<'label', 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9>,
	paymentMethod: {
		label: 'Neznámo',
		label_1: 'Platební karta',
		label_2: 'Bankovní převod',
		label_3: 'Google Pay',
		label_4: 'Apple Pay',
		label_5: 'Terminál v mobilu',
		label_6: 'Hotovost',
		label_7: 'Čip',
		label_8: 'VIP čip',
		label_9: 'Tickets voucher',
		label_10: 'Partnerské',
		label_11: 'Click To Pay',
		label_12: 'Platební karta',
		label_13: 'Google Pay',
		label_14: 'Apple Pay',
		label_15: 'Click To Pay',
	} as const satisfies TypedEnumMap<'label', PAYMENT_METHOD>,
	productCategory: {
		label: 'Neznámo',
		label_1: 'Nealko',
		label_2: 'Pivo',
		label_3: 'Víno',
		label_4: 'Ostatní alkohol',
		label_5: 'Slané',
		label_6: 'Sladké',
		label_7: 'Doplňkový sortiment',
	} as const satisfies TypedEnumMap<'label', EVENT_PRODUCT_CATEGORY>,
	region: {
		label: 'Neznámo',
		label_1: 'Hl. město Praha',
		label_2: 'Středočeský kraj',
		label_3: 'Jihočeský kraj',
		label_4: 'Plzeňský kraj',
		label_5: 'Karlovarský kraj',
		label_6: 'Ústecký kraj',
		label_7: 'Liberecký kraj',
		label_8: 'Královéhradecký kraj',
		label_9: 'Pardubický kraj',
		label_10: 'Kraj Vysočina',
		label_11: 'Jihomoravský kraj',
		label_12: 'Olomoucký kraj',
		label_13: 'Zlínský kraj',
		label_14: 'Moravskoslezský kraj',
		label_201: 'Bratislavský kraj',
		label_202: 'Trnavský kraj',
		label_203: 'Trenčínský kraj',
		label_204: 'Nitranský kraj',
		label_205: 'Žilinský kraj',
		label_206: 'Banskobystrický kraj',
		label_207: 'Prešovský kraj',
		label_208: 'Košický kraj',
		label_301: 'Vídeň',
		label_302: 'Dolní Rakousy',
		label_303: 'Horní Rakousy',
		label_304: 'Štýrsko',
		label_305: 'Korutany',
		label_306: 'Burgenland',
		label_307: 'Salcbursko',
		label_308: 'Tyrolsko',
		label_309: 'Vorarlbersko',
		label_501: 'Vojvodina',
		label_502: 'Bělěhrad',
		label_503: 'Kosovo',
		label_504: 'Metochie',
		label_505: 'Šumadija a Západní Srbsko',
		label_506: 'Jižní a Východní srbsko',
		label_1501: 'Attika',
		label_1502: 'Střední Řecko',
		label_1503: 'Střední Makedonie',
		label_1504: 'Kréta',
		label_1505: 'Východní Makedonie a Thrákie',
		label_1506: 'Epirus',
		label_1507: 'Jónské ostrovy',
		label_1508: 'Severní Egeis',
		label_1509: 'Peloponés',
		label_1510: 'Jižní Egeis',
		label_1511: 'Thessálie',
		label_1512: 'Západní Řecko',
		label_1513: 'Západní Makedonie',
		label_1401: 'Bádensko-Württembersko',
		label_1402: 'Bavorsko',
		label_1403: 'Berlín',
		label_1404: 'Brandenburg',
		label_1405: 'Brema',
		label_1406: 'Hamburg',
		label_1407: 'Hesensko',
		label_1408: 'Dolní Sasko',
		label_1409: 'Mecklenbursko-Vorpommern',
		label_1410: 'Severní Porýní-Vestfálsko',
		label_1411: 'Rheinland-Pfalz',
		label_1412: 'Saarland',
		label_1413: 'Sasko',
		label_1414: 'Sasko-Anhalt',
		label_1415: 'Šlesvicko-Holštýnsko',
		label_1416: 'Thuringia',
	} as const satisfies TypedEnumMap<'label', REGION>,
	sectionType: {
		label: 'Neznámo',
		label_1: 'Populární',
		label_2: 'Náš výběr',
		label_3: 'Právě probíhá',
		label_4: 'Tento víkend',
		label_5: 'Právě oznámeno',
		label_6: 'Specialita',
		label_7: 'Blízko mě',
		/** TODO: missing core enum SECTION_TYPE */
	} as const satisfies TypedEnumMap<'label', 1 | 2 | 3 | 4 | 5 | 6 | 7>,
	venueType: {
		label: 'Neznámo',
		label_1: 'Stadion',
		label_2: 'Kemp',
		label_3: 'Areál na louce',
		label_4: 'Venkovní divadlo/kino',
		label_5: 'Divadlo/kino',
		label_6: 'Město',
		label_7: 'Hudební klub',
		/** TODO: missing core enum VENUE_TYPE */
	} as const satisfies TypedEnumMap<'label', 1 | 2 | 3 | 4 | 5 | 6 | 7>,
} as const;
